import { observer } from "mobx-react-lite";
import { Container, Grid, Header, Table } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { useStore } from "../../../app/stores/store";
import {
  formatCurrency,
} from "../../../app/common/util/functions";
import PageHeader from "../../../app/layout/PageHeader";

interface Props {
  startDate: Date;
  endDate: Date;
}

export default observer(function InventoryRecommendedPrint({
  startDate,
  endDate,
}: Props) {
  const { t } = useTranslation(["common", "reports"]);

  const { recommendedInventoryReportStore } = useStore();
  const { getRecommendedInventoryReport } = recommendedInventoryReportStore;

  return (
    <>
      <Container className="page">
        <Grid stackable columns={2} className="headerPrint">
          <Grid.Row>
            <Grid.Column>
              <PageHeader
                header={`${t("report", { ns: "reports" })}: ${t(
                  "inv_recommended",
                  {
                    ns: "reports",
                  }
                )}`}
                type="h2"
                divider={false}
                getAlerts={true}
                addTitle={true}
              />
            </Grid.Column>
            <Grid.Column>
              <Header
                content={`${format(startDate, "PP")} - ${format(
                  endDate,
                  "PP"
                )}`}
                as="h2"
                textAlign="right"
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {getRecommendedInventoryReport && getRecommendedInventoryReport.length > 0 && (
          <Table striped unstackable className="dnxTable">
            <>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell textAlign="left">
                    {t("part_number", { ns: "reports" })}
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    {t("description", { ns: "common" })}
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    {t("stock_item_location", { ns: "reports" })}
                  </Table.HeaderCell>
                  <Table.HeaderCell>
                    {t("pops.qty", { ns: "tickets" })}
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="right">
                    {t("estimate.price", { ns: "tickets" })}
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="right">
                    {t("total_sales.header", { ns: "reports" })}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {getRecommendedInventoryReport.map((recomInv) => (
                  <Table.Row key={recomInv.id}>
                    <Table.Cell
                      className='hoveredLink'
                      onClick={() => window.open(`/inventoryIndex/partDetails/${recomInv.partId}`, '_blank')}
                      data-label={`${t("part_number", { ns: "reports" })}:`}
                    >
                      {recomInv.partNumber}
                    </Table.Cell>
                    <Table.Cell
                      data-label={`${t("description", {
                        ns: "common",
                      })}:`}
                    >
                      {recomInv.partDescription}
                    </Table.Cell>
                    <Table.Cell
                      data-label={`${t("stock_item", { ns: "reports" })}:`}
                    >
                      {recomInv.location ?? "No Location Assigned"}
                    </Table.Cell>
                    <Table.Cell
                      data-label={`${t("pops.qty", { ns: "tickets" })}:`}
                    >
                      {recomInv.quantity}
                    </Table.Cell>
                    <Table.Cell
                      data-label={`${t("estimate.price", { ns: "tickets" })}:`}
                      textAlign="right"
                    >
                      {formatCurrency(recomInv.price!)}
                    </Table.Cell>
                    <Table.Cell
                      data-label={`${t("total_sales.header", { ns: "reports" })}:`}
                      textAlign="right"
                    >
                      {formatCurrency(recomInv.totalSales!)}
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </>
          </Table>
        )}
      </Container>
    </>
  );
});
